import { render, staticRenderFns } from "./StepGeneratePolicyLoading.vue?vue&type=template&id=26964770&"
import script from "./StepGeneratePolicyLoading.vue?vue&type=script&lang=js&"
export * from "./StepGeneratePolicyLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports